<div class="col-12 md:col-12">
  <div class="surface-card p-4 shadow-2 border-round">
    <div class="text-3xl font-medium text-900 mb-3">Credit Check</div>
    <app-customer-select></app-customer-select>
    <br />
    <button pButton (click)="checkCredit()">Check Selected Credit</button>
  </div>
</div>
